import { BaseComponent } from "react-vextensions";
import React from "react";
import RCSlider, { Range as RCRange } from "rc-slider";
/*type RCSlider_Type = import("rc-slider");
const RCSlider = require("rc-slider");*/
export class Slider extends BaseComponent {
    render() {
        const { value, enabled, instant, onChange, ...rest } = this.props;
        const { editedValue } = this.state;
        return (React.createElement(RCSlider, { ref: c => this.slider = c, ...rest, disabled: !enabled, value: editedValue != null ? editedValue : (value || 0), onChange: val => {
                if (!instant) {
                    this.SetState({ editedValue: val });
                }
                else {
                    onChange(val);
                    this.SetState({ editedValue: null });
                }
            }, onAfterChange: val => {
                if (!instant && onChange) {
                    onChange(val);
                    this.SetState({ editedValue: null });
                }
            } }));
    }
}
Slider.defaultProps = { enabled: true };
//export {Range} from "rc-slider";
export class Range extends BaseComponent {
    render() {
        const { value, enabled, instant, onChange, ...rest } = this.props;
        const { editedValue } = this.state;
        return (React.createElement(RCRange, { ref: c => this.slider = c, ...rest, disabled: !enabled, value: editedValue != null ? editedValue : (value || 0), onChange: val => {
                if (!instant) {
                    this.SetState({ editedValue: val });
                }
                else {
                    onChange(val);
                    this.SetState({ editedValue: null });
                }
            }, onAfterChange: val => {
                if (!instant && onChange) {
                    onChange(val);
                    this.SetState({ editedValue: null });
                }
            } }));
    }
}
Range.defaultProps = { enabled: true };
//# sourceMappingURL=Slider.js.map